const messages = {
  title: 'Tilgang nekta',
  description: 'Du har ikkje tilgang til denne ressursen',
  backHomeButton: 'Attende til dashbord'
}

export default {
  messages
}
